import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import './Question.css';

const shuffleArray = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

const Question = ({ isOpen, toggleSidebar, handleLogout }) => {
  const { kategori } = useParams();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [questions, setQuestions] = useState([]);
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchCategoryId = async () => {
      try {
        const response = await fetch(`https://freddway-v2.credibug.com/api/kategori`);
        if (response.ok) {
          const categories = await response.json();
          const category = categories.find(cat => cat.title === kategori);
          if (category) {
            fetchQuestionsByCategory(category.id);
          } else {
            console.error('Kategori tidak ditemukan');
          }
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
  
    const fetchQuestionsByCategory = async (categoryId) => {
      try {
        const response = await fetch(`https://freddway-v2.credibug.com/api/kuisioner/kategori/${categoryId}`);
        if (response.ok) {
          const data = await response.json();
          setQuestions(data);
          setShuffledQuestions(shuffleArray(data));
        } else {
          console.error('Failed to fetch questions');
        }
      } catch (error) {
        console.error('Error fetching questions:', error);
      }
    };
  
    fetchCategoryId();
  }, [kategori]);
  

  const handleScoreChange = (questionId, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: parseInt(value, 10),
    }));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleSubmit = () => {
    const totalScore = Object.values(answers).reduce((acc, score) => acc + score, 0);
    navigate('/summary', { state: { username: 'Nama Akun', score: totalScore } });
  };

  const questionsPerPage = 5;
  const totalPages = Math.ceil(shuffledQuestions.length / questionsPerPage);
  const startIndex = (currentPage - 1) * questionsPerPage;
  const currentQuestions = shuffledQuestions.slice(startIndex, startIndex + questionsPerPage);

  return (
    <div className="dashboard">
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
      <div className={`main-content ${isOpen ? 'expanded' : ''}`}>
        <div className="pertanyaan-container">
          <h2>Pertanyaan untuk Kategori: {kategori}</h2>
          <ul className="pertanyaan-list">
            {currentQuestions.map((question) => (
              <li key={question.id} className="pertanyaan-item">
                <p className="pertanyaan-text">{question.pertanyaan}</p>
                <div className="range-options">
                  {[1, 2, 3, 4, 5].map((value) => (
                    <div key={value} className="range-option">
                      <label>
                        <input
                          type="radio"
                          name={`question-${question.id}`}
                          value={value}
                          onChange={() => handleScoreChange(question.id, value)}
                        />
                        {value}
                      </label>
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
          <div className="navigation-buttons">
            <button
              onClick={handlePreviousPage}
              className={`navigation-button ${currentPage === 1 ? 'disabled' : ''}`}
              disabled={currentPage === 1}
            >
              Sebelumnya
            </button>
            {currentPage < totalPages ? (
              <button onClick={handleNextPage} className="navigation-button">
                Berikutnya
              </button>
            ) : (
              <button onClick={handleSubmit} className="navigation-button">
                Kirim Jawaban
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Question;
